import React from 'react'
import {
  Box,
  Typography
} from '@mui/material'
import { SUBSCRIPTIONS_DEFAULT_DISCOUNT_PERCENTAGE } from 'modules/subscription/constants'
import ButtonText from 'components/ButtonText'
import Checkbox from 'components/Checkbox'
import useSelector from 'hooks/use-selector'
import updateSubscriptionSellingPlanIdVariantAction from 'modules/variant/redux/actions/update-subscription-selling-plan-id'
import useDispatch from 'hooks/use-dispatch'
import Span from 'components/Span'
import TextSemiBold from 'components/TextSemiBold'
import Underlined from 'components/Underlined'
import getSelectedSubscriptionSellingPlanIdVariantSelector from 'modules/variant/redux/selectors/get-selected-subscription-selling-plan-id'
import getSubscriptionSellingPlanIdVariantSelector from 'modules/variant/redux/selectors/get-subscription-selling-plan-id'
import getSelectedSubscriptionSellingPlanRecurrenceLabelByIdVariantSelector from 'modules/variant/redux/selectors/subscription-info/get-selected-selling-plan-recurrence-label-by-id'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import openRecurrenceSidebarSubscriptionAction from 'modules/subscription/redux/actions/open-recurrence-sidebar'

const TITLE = <Span>Subscribe & Save <TextSemiBold>{SUBSCRIPTIONS_DEFAULT_DISCOUNT_PERCENTAGE}%</TextSemiBold> extra.</Span>

const ANALYTICS_EVENT = {
  SELECT_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP_BUTTON: 'SELECT_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP_BUTTON'
}

/**
 * @param props
 * @param props.variantId
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarSubscribeAndSaveCheckbox (props) {
  const {
    variantId
  } = props
  const dispatch = useDispatch()
  const recurrenceLabel = useSelector(
    getSelectedSubscriptionSellingPlanRecurrenceLabelByIdVariantSelector({
      variantId,
      isShort: true
    })
  )
  const selectedSubscriptionSellingPlanId = useSelector(
    getSelectedSubscriptionSellingPlanIdVariantSelector(variantId)
  )
  const subscriptionSellingPlanId = useSelector(
    getSubscriptionSellingPlanIdVariantSelector(variantId)
  )

  const debugProps = {
    selectedSubscriptionSellingPlanId,
    subscriptionSellingPlanId,
    props
  }
  logUtil('QuickShopProductSidebarSubscribeAndSaveCheckbox').debug('debugProps=', debugProps)

  const handleClickRecurrence = () => {
    dispatch(
      openRecurrenceSidebarSubscriptionAction({
        variantId
      })
    )
  }

  const handleChangeSubscription = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SELECT_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP_BUTTON)
    logUtil('QuickShopProductSidebarSubscribeAndSaveCheckbox#handleChangeSubscription').debug('[start]')
    dispatch(
      updateSubscriptionSellingPlanIdVariantAction({
        variantId,
        value: subscriptionSellingPlanId
          ? null
          : selectedSubscriptionSellingPlanId
      })
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '0.75rem',
        width: '100%',
        justifyContent: 'flex-start'
      }}
    >
      <Checkbox
        checked={!!subscriptionSellingPlanId}
        onChange={handleChangeSubscription}
        name='subscription'
        sx={{
          height: '20px',
          width: '20px',
          '& .MuiSvgIcon-root': {
            height: '20px',
            width: '20px'
          }
        }}
        iconStyle={{
          minWidth: '20px'
        }}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '0.5rem'
        }}
      >
        <Typography
          variant='body1'
          style={{
            color: '#191531',
            fontSize: '14px',
            lineHeight: '14px'
          }}
        >
          {TITLE}
        </Typography>

        <ButtonText
          onClick={handleClickRecurrence}
          style={{
            fontSize: '14px',
            lineHeight: '14px'
          }}
        >
          <Underlined>
            {recurrenceLabel}
          </Underlined>
        </ButtonText>
      </Box>
    </Box>
  )
}
